import * as actionTypes from './actionsTypes';

export const setstudentno = (payload) => {
    return {
        type: actionTypes.SETSTUDENTNO,
        value: payload
    }
}